module.exports = __webpack_public_path__ + "img/end_screen.54625699.png";